import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorMsg } from '../../../helper/errorMessages';
import { openErrorDialog } from '../../errorDialogSlice/errorDialogSlice';
import { getSelectedHouseId } from '../../houses/housesSelectors';
import changeSelectedChannelId from './changeSelectedChannelId';
import fetchCurrentUserChannels from './fetchCurrentUserChannels';

const createChannel = createAsyncThunk(
  'channels/createChannel',
  async ({ userIds }, { dispatch, rejectWithValue, getState, extra: { gccApiClient } }) => {
    const selectedHouseId = getSelectedHouseId(getState());

    try {
      const response = await gccApiClient.createDirectChannel(userIds, selectedHouseId);

      // Handles response errors
      if (response.error_code) {
        dispatch(
          openErrorDialog({
            dialogErrorButtonText: 'Zurück',
            dialogErrorMsg: getErrorMsg(response.error_code) || getErrorMsg('create_channel.default'),
            dialogErrorTitle: 'Fehler',
          }),
        );
        return rejectWithValue({ error: response.error_code });
      }

      await dispatch(fetchCurrentUserChannels({ specificChannelId: response?.id }));
      dispatch(changeSelectedChannelId({ selectedChannelId: response?.id }));

      return { success: response };
    } catch (_error) {
      // Handles offline errors
      return dispatch(
        openErrorDialog({
          dialogErrorButtonText: 'Zurück',
          dialogErrorMsg: 'Sie haben keine Verbindung zum Internet. Bitte versuchen Sie es erneut.',
          dialogErrorTitle: 'Fehler',
        }),
      );
    }
  },
);

export default createChannel;
